module.exports = __webpack_public_path__ + "img/no-contrats.eece4c42.svg";